/*
 * @Author: w
 * @Date: 2022-04-13 19:26:20
 * @LastEditors: xuqiang@mingxinsk.com
 * @LastEditTime: 2024-01-15 16:29:09
 */
import type { RouteRecordRaw } from 'vue-router';

export const asyncRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'main',
    component: () => import(/*webpackChunkName:"layout"*/ '@/views/layout/layout.vue'),
    redirect: '/home',
    meta: {
      title: '首页',
      isMenu: true
    },
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {
          title: '首页',
          isMenu: false,
        },
        component: () => import(/*webpackChunkName:"home"*/ '@/views/home/index.vue'),
      }
    ]
  },
  {
    path: '/enterprise',
    name: 'enterprise',
    redirect: '/enterprise/management/managementList',
    component: () => import(/*webpackChunkName:"enterprise"*/ '@/views/layout/layout.vue'),
    meta: {
      title: '我的企业',
      isMenu: true
    },
    children: [
      {
        path: '/enterprise/employee',
        name: 'employee',
        meta: {
          title: '企业成员管理',
          isMenu: false,
        },
        component: () => import(/*webpackChunkName:"employee"*/ '@/views/layout/blank.vue'),
        children: [
          {
            path: '/enterprise/employee/employeeList',
            name: 'employeeList',
            meta: {
              title: '企业成员管理',
              isMenu: true,
            },
            component: () => import(/*webpackChunkName:"employeeList"*/ '@/views/enterprise/employeeList.vue')
          },
        ]
      },
      {
        path: '/enterprise/management',
        name: 'management',
        meta: {
          title: '企业管理',
          isMenu: true
        },
        component: () => import(/*webpackChunkName:"enterpriseManagement"*/ '@/views/layout/blank.vue'),
        children: [
          {
            path: '/enterprise/management/join',
            name: 'join',
            meta: {
              title: '加入企业',
              isMenu: true
            },
            component: () => import(/*webpackChunkName:"join"*/ '@/views/enterprise/join.vue'),
          },
          {
            path: '/enterprise/management/add',
            name: 'add',
            meta: {
              title: '创建企业',
              isMenu: true,

            },
            component: () => import(/*webpackChunkName:"enterpriseAdd"*/ '@/views/enterprise/add.vue'),
          },
          {
            path: '/enterprise/management/managementList/edit',
            name: 'edit',
            meta: {
              title: '编辑企业',
              isMenu: false
            },
            component: () => import(/*webpackChunkName:"edit"*/ '@/views/enterprise/edit.vue'),
          },
          {
            path: '/enterprise/management/managementList',
            name: 'managementList',
            meta: {
              title: '所属企业列表',
              isMenu: true,
            },
            component: () => import(/*webpackChunkName:"managementList"*/ '@/views/enterprise/list.vue'),
          },
        ]
      },
      {
        path: '/enterprise/empower',
        name: 'empower',
        meta: {
          title: '数据授权',
          isMenu: true
        },
        component: () => import(/*webpackChunkName:"empower"*/ '@/views/layout/blank.vue'),
        children: [
          {
            path: '/enterprise/empower/amazonDataLicensing',
            name: 'amazonDataLicensing',
            meta: {
              title: '亚马逊卖家数据授权',
              isMenu: false
            },
            component: () => import(/*webpackChunkName:"amazonDataLicensing"*/ '@/views/finance/empower/amazonDataLicensing.vue'),
          },
          {
            path: '/enterprise/empower/declareListcp',
            name: 'declareListcp',
            meta: {
              title: '报关单授权下载',
              isMenu: false
            },
            component: () => import(/*webpackChunkName:"declareListcp"*/ '@/views/order/list.vue'),
          },
          {
            path: '/enterprise/empower/shopList',
            name: 'shopList',
            meta: {
              title: '店铺列表',
              isMenu: false
            },
            component: () => import(/*webpackChunkName:"amazonDataLicensing"*/ '@/views/finance/shop/index.vue'),
          },
        ]
      },
      {
        path: '/enterprise/supplierManagement',
        name: 'supplierManagement',
        meta: {
          title: '供应商管理',
          isMenu: true
        },
        component: () => import(/*webpackChunkName:"supplierManage"*/ '@/views/layout/blank.vue'),
        children: [
          {
            path: '/enterprise/supplierManagement/supplierList',
            name: 'supplierList',
            meta: {
              title: '供应商列表',
              isMenu: false
            },
            component: () => import(/*webpackChunkName:"supplierList"*/ '@/views/enterprise/supplierManagement/list.vue'),
          }
        ]
      },
      {
        path: '/enterprise/bankManagement',
        name: 'bankManagement',
        meta: {
          title: '银行管理',
          isMenu: true
        },
        component: () => import(/*webpackChunkName:"supplier"*/ '@/views/layout/blank.vue'),
        children: [
          {
            path: '/enterprise/bankManagement/bankList',
            name: 'bankList',
            meta: {
              title: '银行列表',
              isMenu: false
            },
            component: () => import(/*webpackChunkName:"bankList"*/ '@/views/enterprise/bankManagement/list.vue'),
          }
        ]
      },
      {
        path: '/enterprise/corporateAccounts',
        name: 'corporateAccounts',
        meta: {
          title: '企业账号',
          isMenu: true
        },
        component: () => import(/*webpackChunkName:"corporateAccounts"*/ '@/views/layout/blank.vue'),
        children: [
          {
            path: '/enterprise/corporateAccounts/enterpriseOrders',
            name: 'enterpriseOrders',
            meta: {
              title: '企业订单',
              isMenu: true
            },
            component: () => import(/*webpackChunkName:"enterpriseOrders"*/ '@/views/enterprise/corporateAccounts/enterpriseOrders.vue'),
          },
          {
            path: '/enterprise/corporateAccounts/corporateBilling',
            name: 'corporateBilling',
            meta: {
              title: '企业账单',
              isMenu: true
            },
            component: () => import(/*webpackChunkName:"corporateBilling"*/ '@/views/enterprise/corporateAccounts/corporateBilling.vue'),
          },
        ]
      },

      {
        path: '/enterprise/noAuthEnterprise',
        name: 'noAuthEnterprise',
        meta: {
          title: '无权限页面',
          isMenu: false
        },
        component: () => import(/*webpackChunkName:"noAuthEnterprise"*/ '@/views/layout/blank.vue'),
        children: [
          {
            path: '/enterprise/noAuthEnterprise/noAuthEnterpriseIndex',
            name: 'noAuthEnterpriseIndex',
            meta: {
              title: '未开通权限',
              isMenu: false
            },
            component: () => import(/*webpackChunkName:"noAuthEnterpriseIndex"*/ '@/views/noAuth/index.vue'),
          }
        ]
      },
    ]
  },
  {
    path:'/help',
    name:'Help',
    meta:{
      isMenu: false,
      title:'操作指引',
    },
    component: () => import(/*webpackChunkName:"layout"*/ '@/views/layout/layout.vue'),
    children:[
      {
        path:'/help/quickstart',
        name:'quickstart',
        meta:{
          title: '快速入门',
          isMenu: true
        },
        component: () => import(/*webpackChunkName:"layout"*/ '@/views/layout/blank.vue'),
        children: [{
          path:'/help/quickstart/sys',
          name:'sys',
          meta:{
            title: '系统操作流程图（跨境卖家版）',
            isMenu: true
          },
          component: () => import(/*webpackChunkName:"layout"*/ '@/views/help/index.vue'),
        }]
      },
      {
        path:'/help/create',
        name:'create',
        meta:{
          title: '创建/加入企业',
          isMenu: true
        },
        component: () => import(/*webpackChunkName:"layout"*/ '@/views/help/index.vue'),
        children: [{
          path:'/help/create/firm',
          name:'firm',
          meta:{
            title: '创建企业/加入企业',
            isMenu: true
          },
          component: () => import(/*webpackChunkName:"layout"*/ '@/views/help/index.vue'),
        }]
      },
      {
        path:'/help/settled',
        name:'settled',
        meta:{
          title: '入驻跨赋平台',
          isMenu: true
        },
        component: () => import(/*webpackChunkName:"layout"*/ '@/views/layout/blank.vue'),
        children: [
          {
            path:'/help/settled/ec',
            name:'ec',
            meta:{
              title: '跨境卖方入驻跨赋平台',
              isMenu: true
            },
            component: () => import(/*webpackChunkName:"layout"*/ '@/views/help/index.vue'),
          },
          {
            path:'/help/settled/logistics',
            name:'logistics',
            meta:{
              title: '物流企业入驻跨赋平台',
              isMenu: true
            },
            component: () => import(/*webpackChunkName:"layout"*/ '@/views/help/index.vue'),
          },
          {
            path:'/help/settled/crossborder',
            name:'crossborder',
            meta:{
              title: '跨境服务平台入驻跨赋平台',
              isMenu: true
            },
            component: () => import(/*webpackChunkName:"layout"*/ '@/views/help/index.vue'),
          },
        ]
      },
      {
        path:'/help/serverorder',
        name:'serverorder',
        meta:{
          title: '发起委托单',
          isMenu: true
        },
        component: () => import(/*webpackChunkName:"layout"*/ '@/views/layout/blank.vue'),
        children: [
          {
            path:'/help/serverorder/production',
            name:'production',
            meta:{
              title: '生产企业发起委托单',
              isMenu: true
            },
            component: () => import(/*webpackChunkName:"layout"*/ '@/views/help/index.vue'),
          },
          {
            path:'/help/serverorder/foreigntrade',
            name:'foreigntrade',
            meta:{
              title: '外贸企业发起委托单',
              isMenu: true
            },
            component: () => import(/*webpackChunkName:"layout"*/ '@/views/help/index.vue'),
          },
        ]
      },
    ]
  },
  {
    path: '/lx',
    name: 'lx',
    meta: {
      title: '领秀',
      isMenu: false
    },
    component: () => import(/*webpackChunkName:"declare"*/ '@/views/layout/blank.vue'),
    children: [{
      path: '/lx/bigScreen',
      name: 'bigScreen',
      meta: {
        title: '领秀跨赋平台',
        isMenu: false
      },
      component: () => import(/*webpackChunkName:"bigScreen"*/ '@/views/lx/bigScreen.vue'),
    }]
  },
  {
    path: '/questionaryDetailAi',
    name: 'questionaryDetailAi',
    meta: {
      title: '企业调查表',
    },
    component: () => import(/*webpackChunkName:"questionaryDetailAi"*/ '@/views/fpaManagement/CollectionOfTaxRefundEnterpriseInformation/businessQuestionnaire/detail.vue'),
  },
  {
    path: '/taxRefundConsultant',
    name: 'taxRefundConsultant',
    component: () => import(/*webpackChunkName:"layout"*/ '@/views/layout/layout.vue'),
    redirect: '/taxRefundConsultant/index',
    meta: {
      title: '退税咨询助手',
      isMenu: true
    },
    children: [
      {
        path: '/taxRefundConsultant/index',
        name: 'taxRefundConsultantIndex',
        meta: {
          title: '退税咨询助手',
          isMenu: false,
        },
        component: () => import(/*webpackChunkName:"home"*/ '@/views/ai-chat/home.vue'),
      }
    ]
  },
]
// 报关模块
export const declareRoutes: RouteRecordRaw =
{
  path: '/declare',
  name: 'declare',
  redirect: '/declare/sigle/export',
  meta: {
    title: '报关',
    isMenu: true,
    // roles:['ROLE_ADMIN','ROLE_ADMIN_ORDINARY','ROLE_CUSTOMS_CLEARANCE_GENERAL']
  },
  component: () => import(/*webpackChunkName:"declare"*/ '@/views/layout/blank.vue'),
  children: [
    // {
    //   path: '/declare/admin',
    //   name: 'admin',
    //   meta: {
    //     title: '报关单列表',
    //     isMenu: false,
    //   },
    //   component: () => import(/*webpackChunkName:"admin"*/ '@/views/layout/layout.vue'),
    //   children: [
    //     {
    //       path: '/declare/admin/declareList',
    //       name: 'declareList',
    //       meta: {
    //         title: '报关单列表',
    //         isMenu: true,
    //       },
    //       component: () => import(/*webpackChunkName:"declareList"*/ '@/views/order/list.vue'),
    //     },
    //     {
    //       path: '/declare/admin/declareList/logisticsDetail',
    //       name: 'logisticsDetail',
    //       meta: {
    //         title: '物流查询',
    //         isMenu: true,
    //       },
    //       component: () => import(/*webpackChunkName:"declareList"*/ '@/views/order/logisticsDetail.vue'),
    //     },
    //     {
    //       path: '/declare/admin/declareList/declareDetail',
    //       name: 'declareDetail',
    //       meta: {
    //         title: '报关单详情',
    //         isMenu: false,
    //       },
    //       component: () => import(/*webpackChunkName:"declareDetail"*/ '@/views/order/list/0110/detail.vue'),
    //     },
    //     {
    //       path: '/declare/admin/declareList/declareDetail9610',
    //       name: 'declareDetail9610',
    //       meta: {
    //         title: '报关单详情',
    //         isMenu: false,
    //       },
    //       component: () => import(/*webpackChunkName:"declareDetail9610"*/ '@/views/order/list/detail9610.vue'),
    //     },
    //     {
    //       path: '/declare/admin/declareList/relationOrder',
    //       name: 'relationOrder',
    //       meta: {
    //         title: '关联单证',
    //         isMenu: false,
    //       },
    //       component: () => import(/*webpackChunkName:"relationOrder"*/ '@/views/order/list/relationOrder.vue'),
    //     },
    //     {
    //       path: '/declare/admin/declare9610List',
    //       name: 'declare9610List',
    //       meta: {
    //         title: '9610清单列表',
    //         isMenu: false,
    //         },
    //       component: () => import(/*webpackChunkName:"declare9610List"*/ '@/views/order/list/9610/detail-list.vue'),
    //     },
    //     {
    //       path: '/declare/admin/declareList/declare9610ListDetail',
    //       name: 'declare9610ListDetail',
    //       meta: {
    //         title: '报关单详情',
    //         isMenu: false,
    //       },
    //       component: () => import(/*webpackChunkName:"declare9610ListDetail"*/ '@/views/order/list/9610/detail-list-detail.vue'),
    //     },
    //     {
    //       path: '/declare/saleOrderDetail',
    //       name: 'saleOrderDetail',
    //       meta: {
    //         title: '关联单据',
    //         isMenu: false,
    //       },
    //       component: () => import(/*webpackChunkName:"saleOrderDetail"*/ '@/views/order/list/saleOrderDetail.vue'),
    //     },
    //   ]
    // },
    {
      path: '/declare/commodityClassification2',
      name: 'commodityClassification2',
      meta: {
        title: '商品归类',
        isMenu: false,
      },
      component: () => import(/*webpackChunkName:"consign"*/ '@/views/layout/layout.vue'),
      children: [
        {
          path: '/declare/commodityClassification2/commodityClassificationIndex',
          name: 'commodityClassificationIndex',
          meta: {
            title: '商品归类',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"commodityClassification2"*/ '@/views/order/record/commodityClassification.vue'),
        }
      ]
    },
    {
      path: '/declare/ecommerce',
      name: 'ecommerce',
      meta: {
        title: '跨境电商',
        isMenu: false,
      },
      component: () => import(/*webpackChunkName:"consign"*/ '@/views/layout/layout.vue'),
      children:[
        {
          path: '/declare/ecommerce/messageOrderList',
          name: 'messageOrderList',
          meta: {
            title: '订单列表',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"messageOrderList"*/ '@/views/declare/ecommerce/messageOrderList.vue'),
        },
        {
          path: '/declare/ecommerce/messageOrderDetail',
          name: 'messageOrderDetail',
          meta: {
            title: '订单详情',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"messageOrderDetail"*/ '@/views/declare/ecommerce/messageOrderDetail.vue'),
        },
        {
          path: '/declare/ecommerce/messageWaybillList',
          name: 'messageWaybillList',
          meta: {
            title: '运单列表',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"messageWaybillList"*/ '@/views/declare/ecommerce/messageWaybillList.vue'),
        },
        {
          path: '/declare/ecommerce/messageWaybillDetail',
          name: 'messageWaybillDetail',
          meta: {
            title: '运单详情',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"messageWaybillDetail"*/ '@/views/declare/ecommerce/messageWaybillDetail.vue'),
        },
        {
          path: '/declare/ecommerce/messageChecklist',
          name: 'messageChecklist',
          meta: {
            title: '清单列表',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"messageChecklist"*/ '@/views/declare/ecommerce/messageChecklist.vue'),
        },
        {
          path: '/declare/ecommerce/messageCheckDetail',
          name: 'messageCheckDetail',
          meta: {
            title: '清单详情',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"messageCheckDetail"*/ '@/views/declare/ecommerce/messageCheckDetail.vue'),
        },
        {
          path: '/declare/ecommerce/messagelistTotalScoreList',
          name: 'messagelistTotalScoreList',
          meta: {
            title: '清单总分单列表',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"messagelistTotalScoreList"*/ '@/views/declare/ecommerce/messagelistTotalScoreList.vue'),
        },
        {
          path: '/declare/ecommerce/messagelistTotalScoreDetail',
          name: 'messagelistTotalScoreDetail',
          meta: {
            title: '清单总分单详情',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"messagelistTotalScoreDetail"*/ '@/views/declare/ecommerce/messagelistTotalScoreDetail.vue'),
        },
        {
          path: '/declare/ecommerce/messageArrivalList',
          name: 'messageArrivalList',
          meta: {
            title: '运抵单列表',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"messageArrivalList"*/ '@/views/declare/ecommerce/messageArrivalList.vue'),
        },
        {
          path: '/declare/ecommerce/messageArrivalDetail',
          name: 'messageArrivalDetail',
          meta: {
            title: '运抵单详情',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"messageArrivalDetail"*/ '@/views/declare/ecommerce/messageArrivalDetail.vue'),
        },
        {
          path: '/declare/ecommerce/messageDepartureOrderList',
          name: 'messageDepartureOrderList',
          meta: {
            title: '离境单列表',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"messageDepartureOrderList"*/ '@/views/declare/ecommerce/messageDepartureOrderList.vue'),
        },
        {
          path: '/declare/ecommerce/messageDepartureOrderDetail',
          name: 'messageDepartureOrderDetail',
          meta: {
            title: '离境单详情',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"messageDepartureOrderDetail"*/ '@/views/declare/ecommerce/messageDepartureOrderDetail.vue'),
        },
        {
          path: '/declare/ecommerce/messageSummaryApplicationList',
          name: 'messageSummaryApplicationList',
          meta: {
            title: '汇总申请单列表',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"messageSummaryApplicationList"*/ '@/views/declare/ecommerce/messageSummaryApplicationList.vue'),
        },
        {
          path: '/declare/ecommerce/messageSummaryApplicationDetail',
          name: 'messageSummaryApplicationDetail',
          meta: {
            title: '汇总申请单详情',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"messageSummaryApplicationDetail"*/ '@/views/declare/ecommerce/messageSummaryApplicationDetail.vue'),
        },
        {
          path: '/declare/ecommerce/messagelist9610InventoryList',
          name: 'messagelist9610InventoryList',
          meta: {
            title: '9610出口',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"messagelist9610InventoryList"*/ '@/views/declare/ecommerce/messagelist9610InventoryList.vue'),
        },
        {
          path: '/declare/ecommerce/messagelist9710InventoryList',
          name: 'messagelist9710InventoryList',
          meta: {
            title: '9710出口',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"messagelist9710InventoryList"*/ '@/views/declare/ecommerce/messagelist9710InventoryList.vue'),
        },
        {
          path: '/declare/ecommerce/messageBillofLadingList',
          name: 'messageBillofLadingList',
          meta: {
            title: '提运单管理',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"messageBillofLadingList"*/ '@/views/declare/ecommerce/messageBillofLadingList.vue'),
        },
        {
          path: '/declare/ecommerce/messageSummaryApplicationStagingList',
          name: 'messageSummaryApplicationStagingList',
          meta: {
            title: '汇总申请暂存',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"messageSummaryApplicationStagingList"*/ '@/views/declare/ecommerce/messageSummaryApplicationStagingList.vue'),
        },
        {
          path: '/declare/ecommerce/messageSummaryApplicationExportList',
          name: 'messageSummaryApplicationExportList',
          meta: {
            title: '汇总申请申报',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"messageSummaryApplicationExportList"*/ '@/views/declare/ecommerce/messageSummaryApplicationExportList.vue'),
        },
      ]
    },
    {
      path: '/declare/consign',
      name: 'consign',
      meta: {
        title: '报关委托',
        isMenu: true,
      },
      redirect:'/declare/consign/index',
      component: () => import(/*webpackChunkName:"consign"*/ '@/views/layout/layout.vue'),
      children:[
        {
          path: '/declare/consign/index',
          name: 'consignIndex',
          meta: {
            title: '报关委托',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"consignIndex"*/ '@/views/declare/declareConsign/index.vue'),
        },
        {
          path: '/declare/consign/0110detail',
          name: 'consign0110detail',
          meta: {
            title: '报关单0110详情',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"consign0110detail"*/ '@/views/fpaManagement/list/0110/detail.vue'),
        },
        {
          path: '/declare/consign/9610detail',
          name: 'consign9610detail',
          meta: {
            title: '报关单9610详情',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"consign0110detail"*/ '@/views/fpaManagement/list/9610/detail-list-detail.vue'),
        },
      ]
    },
    {
      path: '/declare/intelligentClassification',
      name: 'intelligentClassification',
      meta: {
        title: '报关单商品归类',
        isMenu: false,
      },
      redirect:'/declare/intelligentClassification/list',
      component: () => import(/*webpackChunkName:"/declare/intelligentClassification"*/ '@/views/layout/layout.vue'),
      children:[
        {
          path: '/declare/intelligentClassification/list',
          name: 'intelligentClassificationList',
          meta: {
            title: '报关单商品归类列表',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"intelligentClassificationList"*/ '@/views/declare/intelligentClassification/list.vue'),
        },
        {
          path: '/declare/intelligentClassification/0110detail',
          name: 'intelligentClassification0110detail',
          meta: {
            title: '报关单0110详情',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"0110detail"*/ '@/views/fpaManagement/list/0110/detail.vue'),
        },
        {
          path: '/declare/intelligentClassification/9610detail',
          name: 'intelligentClassification9610detail',
          meta: {
            title: '报关单9610详情',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"9610detail"*/ '@/views/fpaManagement/list/9610/detail-list-detail.vue'),
        },
      ]
    },
    {
      path: '/declare/sigle',
      name: 'declareSigle',
      meta: {
        title: '自主申报',
        isMenu: true,
      },
      component: () => import(/*webpackChunkName:"declareSigle"*/ '@/views/layout/layout.vue'),
      children: [
        {
          path: '/declare/sigle/declaration',
          name: 'declaration',
          meta: {
            title: '进口报关',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"declaration"*/ '@/views/declare/imp/index.vue'),
        },
        {
          path: '/declare/sigle/export',
          name: 'export',
          meta: {
            title: '出口报关',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"export"*/ '@/views/declare/export/index.vue'),
        },
        {
          path: '/declare/sigle/manifest',
          name: 'manifest',
          meta: {
            title: '公路舱单',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"manifest"*/ '@/views/declare/manifest/index.vue'),
        },
        {
          path: '/declare/sigle/template',
          name: 'template',
          meta: {
            title: '报关模板',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"template"*/ '@/views/declare/temp/index.vue'),
        },
        {
          path: '/declare/sigle/electronicDocument',
          name: 'electronicDocument',
          meta: {
            title: '电子单据',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"electronicDocument"*/ '@/views/declare/electronicDocument/index.vue'),
        },
        {
          path: '/declare/sigle/territorialInspection',
          name: 'territorialInspection',
          meta: {
            title: '属地查检列表',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"territorialInspection"*/ '@/views/declare/territorialInspection/list.vue'),
        },
        {
          path: '/declare/sigle/territorialInspection/territorialInspectionDetail',
          name: 'territorialInspectionDetail',
          meta: {
            title: '属地查检详情',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"territorialInspectionDetail"*/ '@/views/declare/common/detail.vue'),
        },
        {
          path: '/declare/sigle/inspectionAndQuarantine',
          name: 'inspectionAndQuarantine',
          meta: {
            title: '检验检疫列表',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"inspectionAndQuarantine"*/ '@/views/declare/inspection/list.vue'),
        },
        {
          path: '/declare/sigle/inspectionAndQuarantine/inspectionAndQuarantineDetail',
          name: 'inspectionAndQuarantineDetail',
          meta: {
            title: '检验检疫详情',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"inspectionAndQuarantineDetail"*/ '@/views/declare/common/detail.vue'),
        },
        {
          path: '/declare/sigle/certificateApplication',
          name: 'certificateApplication',
          meta: {
            title: '证书申请列表',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"certificateApplication"*/ '@/views/declare/certificateApplication/list.vue'),
        },
        {
          path: '/declare/sigle/oceanBillofLading',
          name: 'oceanBillofLading',
          meta: {
            title: '海运舱单',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"oceanBillofLading"*/ '@/views/declare/oceanBillofLading/list.vue'),
        },
      ],
    },
    {
      path: '/declare/basicData',
      name: 'basicData',
      meta: {
        title: '海关商品基础数据',
        isMenu: true,
      },
      component: () => import(/*webpackChunkName:"basicData"*/ '@/views/layout/layout.vue'),
      children:[
        {
          path: '/declare/basicData/customsCode',
          name: 'customsCode',
          meta: {
            title: '海关编码',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"customsCode"*/ '@/views/declare/decalreBasicData/customsCode.vue'),
        },
        {
          path: '/declare/basicData/ciqCodes',
          name: 'ciqCodes',
          meta: {
            title: 'CIQ编码',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"ciqCodes"*/ '@/views/declare/decalreBasicData/ciqCodes.vue'),
        },
      ]
    },
    // 对接
    {
      path: '/declare/header/order',
      name: 'declareHeaderOrder',
      meta: {
        title: '单抬头申报',
        isMenu: false,
        // roles:['ROLE_ADMIN','ROLE_ADMIN_ORDINARY','ROLE_CUSTOMS_CLEARANCE_GENERAL']
      },
      component: () => import(/*webpackChunkName:"declareHeaderOrder"*/ '@/views/layout/blank.vue'),
      children: [
        {
          path: '/declare/header/order/export',
          name: 'declareHeaderExport',
          meta: {
            title: '出口报关',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"declareHeaderExport"*/ '@/views/declare/export/index.vue'),
        },
        {
          path: '/declare/header/order/manifest',
          name: 'declareHeaderManifest',
          meta: {
            title: '公路舱单',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"declareHeaderManifest"*/ '@/views/declare/manifest/index.vue'),
        },
        {
          path: '/declare/header/order/template',
          name: 'declareHeaderTemplate',
          meta: {
            title: '报关模板',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"declareHeaderTemplate"*/ '@/views/declare/temp/index.vue'),
        },
      ],
    },
    {
      path: '/declare/double/header',
      name: 'declareHeaderDubble',
      meta: {
        title: '双抬头申报',
        isMenu: false,
      },
      component: () => import(/*webpackChunkName:"declareHeaderDubble"*/ '@/views/layout/blank.vue'),
      children: [
        {
          path: '/declare/double/header/order/quick',
          name: 'orderQuickDeclare',
          meta: {
            title: '快捷下单',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"orderQuickDeclare"*/ '@/views/order/quick.vue'),
        },

        {
          path: '/declare/double/header/order/export',
          name: 'orderExportDeclare',
          meta: {
            title: '订单列表',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"orderExportDeclare"*/ '@/views/order/export.vue'),
        },
        {
          path: '/declare/double/header/order/detail',
          name: 'orderDetailDeclare',
          meta: {
            title: '详情',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"orderDetailDeclare"*/ '@/views/order/detail.vue'),
        },
        // {
        //   path:'/order/entrusted',
        //   name:'orderEntrusted',
        //   meta:{
        //     title:'被委托订单',
        //     isMenu:true,
        //   },
        //   component: () => import(/*webpackChunkName:"orderEntrusted"*/ '@/views/order/entrusted.vue'),
        // },
      ]
    },
     {
      path: '/declare/noAuthDeclare',
      name: 'noAuthDeclare',
      meta: {
        title: '无权限页面',
        isMenu: true
      },
      component: () => import(/*webpackChunkName:"noAuthDeclare"*/ '@/views/layout/layout.vue'),
      children: [
        {
          path: '/declare/noAuthDeclare/noAuthDeclareIndex',
          name: 'noAuthDeclareIndex',
          meta: {
            title: '未开通权限',
            isMenu: false
          },
          component: () => import(/*webpackChunkName:"noAuthDeclareIndex"*/ '@/views/noAuth/index.vue'),
        }
      ]
    },
  ]
}

// 工具下载
export const uploadUtilsRoutes: RouteRecordRaw =
{
  path: '/upload',
  name: 'uload',
  meta: {
    title: '工具下载',
    isMenu: false,
  },
  component: () => import(/*webpackChunkName:"layout"*/ '@/views/layout/layout.vue'),
  children: [
    {
      path: '/upload/utils',
      name: 'uloadUtils',
      meta: {
        title: '',
        isMenu: false
      },
      component: () => import(/*webpackChunkName:"uloadUtils"*/ '@/views/uploadUtils/index.vue'),
    },

  ]
}
// 退税模块
export const drawbackRoutes: RouteRecordRaw =
{
  path: '/drawback',
  name: 'drawback',
  redirect: '/drawback/tax',
  meta: {
    title: '退税',
    isMenu: true,
    // roles:['ROLE_ADMIN','ROLE_ADMIN_ORDINARY','ROLE_TAX_REIMBURSEMENT_GENERAL']
  },
  component: () => import(/*webpackChunkName:"drawback"*/ '@/views/layout/layoutNopadding.vue'),
  children: [
    {
      path: '/drawback/tax',
      name: 'drawbackTax',
      meta: {
        title: '退税',
        isMenu: false,
      },
      component: () => import(/*webpackChunkName:"drawbackTax"*/ '@/views/drawback/tax/index.vue'),
    },
    {
      path: '/drawback/noAuthDrawbackIndex',
      name: 'noAuthDrawbackIndex',
      meta: {
        title: '无权限页面',
        isMenu: true
      },
      component: () => import(/*webpackChunkName:"noAuthDrawbackIndex"*/ '@/views/noAuth/index.vue'),
    },
  ]
}
export const drawbackRoutesOst: RouteRecordRaw =
{
  path: '/drawbacks',
  name: 'drawbacks',
  redirect:'/drawbacks/tax',
  meta: {
    title: '退税管理',
    isMenu: false,
    // roles:['ROLE_ADMIN','ROLE_ADMIN_ORDINARY','ROLE_TAX_REIMBURSEMENT_GENERAL']
  },
  component: () => import(/*webpackChunkName:"drawbacks"*/ '@/views/layout/blank.vue'),
  children: [
    {
      path: '/drawbacks/tax',
      name: 'drawbacksTax',
      meta: {
        title: '退税管理',
        isMenu: false,
      },
      component: () => import(/*webpackChunkName:"drawbacksTax"*/ '@/views/drawback/tax/index.vue'),
    },
  ]
}

// 协议模块
export const agreementRouters: RouteRecordRaw = {
  path: '/enterprise/relation',
  name: 'relation',
  meta: {
    title: '企业关系管理',
    isMenu: true,
    // roles:['ROLE_ADMIN','ROLE_ADMIN_ORDINARY','AGREEMENT_ADMIN']
  },
  component: () => import(/*webpackChunkName:"relation"*/ '@/views/layout/layout.vue'),
  children: [
    {
      path: '/enterprise/relation/relationList',
      name: 'relationList',
      meta: {
        title: '协议列表',
        isMenu: true
      },
      component: () => import(/*webpackChunkName:"relationList"*/ '@/views/enterprise/agreeManagement/index.vue'),
    },
    {
      path: '/enterprise/relation/approval',
      name: 'approval',
      meta: {
        title: '协议审批管理',
        isMenu: true
      },
      component: () => import(/*webpackChunkName:"approval"*/ '@/views/enterprise/agreeManagement/approval.vue'),
    },
    {
      path: '/enterprise/relation/corporateRelations',
      name: 'corporateRelations',
      meta: {
        title: '企业关系',
        isMenu: true
      },
      component: () => import(/*webpackChunkName:"corporateRelations"*/ '@/views/enterprise/corporateRelations.vue'),
    },
  ]
}
//fap模块
export const fpaManagement: RouteRecordRaw = {
  path: '/fpaManagement',
  name: 'fpaManagement',
  redirect: '/fpaManagement/dataCount/baoguanCount',
  component: () => import(/*webpackChunkName:"fpaManagement"*/ '@/views/layout/layout.vue'),
  meta: {
    title: 'FAP数据管理',
    isMenu: true
  },
  children: [
    {
      path: '/fpaManagement/dataCount',
      name: 'dataCount',
      meta: {
        title: '数据汇总',
        isMenu: true
      },
      component: () => import(/*webpackChunkName:"dataCount"*/ '@/views/layout/blank.vue'),
      children: [
        {
          path: '/fpaManagement/dataCount/baoguanCount',
          name: 'baoguanCount',
          meta: {
            title: '报关单数据汇总',
            isMenu: false,
            keepAlive: 'declareCount'
          },
          component: () => import(/*webpackChunkName:"baoguanCount"*/ '@/views/fpaManagement/declareCount.vue'),
        },
        {
          path: '/fpaManagement/dataCount/baoguanCount/baoguanCountLogistics',
          name: 'baoguanCountLogistics',
          meta: {
            title: '物流查询',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"declareList"*/ '@/views/order/logisticsDetail.vue'),
        },
        {
          path: '/fpaManagement/dataCount/baoguanCount/baoguanCountLogistics2',
          name: 'baoguanCountLogistics2',
          meta: {
            title: '物流查询',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"declareList"*/ '@/views/order/logisticsDetail2.vue'),
        },
        {
          path: '/fpaManagement/dataCount/companyCount',
          name: 'companyCount',
          meta: {
            title: '企业数据汇总',
            isMenu: true,
            keepAlive: 'enterpriseCountList'
          },
          component: () => import(/*webpackChunkName:"companyCount"*/ '@/views/fpaManagement/enterpriseCount.vue'),
        },
        {
          path: '/fpaManagement/dataCount/relationUserInfo',
          name: 'relationUserInfo',
          meta: {
            title: '用户信息',
            isMenu: true,

          },
          component: () => import(/*webpackChunkName:"relationUserInfo"*/ '@/views/fpaManagement/relationUserInfo.vue'),
        },
        {
          path: '/fpaManagement/dataCount/companyCount/business',
          name: 'business',
          meta: {
            title: '企业数据汇总-业务信息',
            isMenu: true,

          },
          component: () => import(/*webpackChunkName:"business"*/ '@/views/fpaManagement/enterpriseCountBusiness.vue'),
        },
        {
          path: '/fpaManagement/dataCount/baoguanServiceCount',
          name: 'baoguanServiceCount',
          meta: {
            title: '报关委托单数据汇总',
            isMenu: true
          },
          component: () => import(/*webpackChunkName:"baoguanServiceCount"*/ '@/views/fpaManagement/declareServiceCount.vue'),
        },
        {
          path: '/fpaManagement/dataCount/baoguanCount/0110detail',
          name: '0110detail',
          meta: {
            title: '报关单详情',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"0110detail"*/ '@/views/fpaManagement/list/0110/detail.vue'),
        },
        {
          path: '/fpaManagement/dataCount/baoguanCount/9610detail',
          name: '9610detail',
          meta: {
            title: '报关单详情',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"9610detail"*/ '@/views/fpaManagement/list/9610/detail-list-detail.vue'),
        },
        {
          path: '/fpaManagement/dataCount/companyCount/companyCountdetail',
          name: 'companyCountdetail',
          meta: {
            title: '企业详情',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"companyCountdetail"*/ '@/views/enterprise/edit.vue'),
        },
        {
          path: '/fpaManagement/dataCount/baoguanServiceCount/baoguanServiceCountdetail',
          name: 'baoguanServiceCountdetail',
          meta: {
            title: '订单详情',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"baoguanServiceCountdetail"*/ '@/views/fpaManagement/declareServiceCountDetail.vue'),
        },
        {
          path: '/fpaManagement/dataCount/userCount',
          name: 'userCount',
          meta: {
            title: '用户数据汇总',
            isMenu: true
          },
          component: () => import(/*webpackChunkName:"baoguanCount"*/ '@/views/fpaManagement/userCount.vue'),
        },
        {
          path: '/fpaManagement/dataCount/relationCompanyInfo',
          name: 'relationCompanyInfo',
          meta: {
            title: '企业信息',
            isMenu: true
          },
          component: () => import(/*webpackChunkName:"relationCompanyInfo"*/ '@/views/fpaManagement/relationCompanyInfo.vue'),
        },
        {
          path: '/fpaManagement/dataCount/baoguanCount/refundDtail',
          name: 'refundDtail',
          meta: {
            title: '退税申报明细',
            isMenu: false
          },
          component: () => import(/*webpackChunkName:"baoguanCount"*/ '@/views/fpaManagement/refundDtail.vue'),
        },
        {
          path: '/fpaManagement/dataCount/personalAgreementList',
          name: 'personalAgreementList',
          meta: {
            title: '个人协议列表',
            isMenu: true
          },
          component: () => import(/*webpackChunkName:"baoguanCount"*/ '@/views/fpaManagement/personalAgreementList.vue'),
        },
        {
          path: '/fpaManagement/dataCount/companyCount/business/0110detail',
          name: 'business0110detail',
          meta: {
            title: '企业数据汇总-报关单0110详情',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"business0110detail"*/ '@/views/fpaManagement/list/0110/detail.vue'),
        },
        {
          path: '/fpaManagement/dataCount/companyCount/business/9610detail',
          name: 'business9610detail',
          meta: {
            title: '企业数据汇总-报关单9610详情',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"business9610detail"*/ '@/views/fpaManagement/list/9610/detail-list-detail.vue'),
        },
        {
          path: '/fpaManagement/dataCount/companyCount/business/businessServiceCountdetail',
          name: 'businessServiceCountdetail',
          meta: {
            title: '企业数据汇总-出口委托单详情',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"businessServiceCountdetail"*/ '@/views/fpaManagement/declareServiceCountDetail.vue'),
        },
        {
          path: '/fpaManagement/dataCount/relationshipList',
          name: 'relationshipList',
          meta: {
            title: '企业关系一览',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"relationshipList"*/ '@/views/fpaManagement/relationship/list.vue'),
        },
        {
          path: '/fpaManagement/dataCount/refundHelperChatRecord',
          name: 'refundHelperChatRecord',
          meta: {
            title: '退税咨询',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"refundHelperChatRecord"*/ '@/views/fpaManagement/refundHelperChatRecord.vue'),
        },
      ]
    },
    {
      path: '/fpaManagement/electricityBusinessSalesData',
      name: 'electricityBusinessSalesData',
      meta: {
        title: '电商平台销售数据',
        isMenu: true
      },
      component: () => import(/*webpackChunkName:"electricityBusinessSalesData"*/ '@/views/layout/blank.vue'),
      children:[
        {
          path: '/fpaManagement/electricityBusinessSalesData/amazonSalesData',
          name: 'amazonSalesData',
          meta: {
            title: '亚马逊销售数据',
            isMenu: true
          },
          component: () => import(/*webpackChunkName:"amazonSalesData"*/ '@/views/fpaManagement/electricityBusinessSalesData/amazonSalesData.vue'),
        }
      ]
    },
    {
      path: '/fpaManagement/basicDataManagement',
      name: 'basicDataManagement',
      meta: {
        title: '基础数据管理',
        isMenu: true
      },
      component: () => import(/*webpackChunkName:"basicDataManagement"*/ '@/views/layout/blank.vue'),
      children:[
        {
          path: '/fpaManagement/basicDataManagement/rateManagement',
          name: 'rateManagement',
          meta: {
            title: '汇率管理',
            isMenu: true
          },
          component: () => import(/*webpackChunkName:"rateManagement"*/ '@/views/fpaManagement/basicDataManagement/rateManagement.vue'),
        }
      ]
    },
    {
      path: '/fpaManagement/billingSummary',
      name: 'billingSummary',
      meta: {
        title: '账单汇总',
        isMenu: true
      },
      component: () => import(/*webpackChunkName:"billingSummary"*/ '@/views/layout/blank.vue'),
      children:[
        {
          path: '/fpaManagement/billingSummary/flowbookDataSummary',
          name: 'flowbookDataSummary',
          meta: {
            title: '流水账数据汇总',
            isMenu: true
          },
          component: () => import(/*webpackChunkName:"flowbookDataSummary"*/ '@/views/fpaManagement/billingSummary/flowbookDataSummary.vue'),
        },
        {
          path: '/fpaManagement/billingSummary/flowbookDataSummary/flowbookDataSummaryDetail',
          name: 'flowbookDataSummaryDetail',
          meta: {
            title: '流水账详情',
            isMenu: true
          },
          component: () => import(/*webpackChunkName:"flowbookDataSummaryDetail"*/ '@/views/fpaManagement/billingSummary/flowbookDataSummaryDetail.vue'),
        },
        {
          path: '/fpaManagement/billingSummary/ledgerDataSummary',
          name: 'ledgerDataSummary',
          meta: {
            title: '分类账数据汇总',
            isMenu: true
          },
          component: () => import(/*webpackChunkName:"flowbookDataSummaryDetail"*/ '@/views/fpaManagement/billingSummary/ledgerDataSummary.vue'),
        },
        {
          path: '/fpaManagement/billingSummary/ledgerDataSummary/ledgerDataSummaryDetail',
          name: 'ledgerDataSummaryDetail',
          meta: {
            title: '分类账单明细',
            isMenu: true
          },
          component: () => import(/*webpackChunkName:"ledgerDataSummaryDetail"*/ '@/views/fpaManagement/billingSummary/ledgerDataSummaryDetail.vue'),
        },
      ]
    },
    {
      path: '/fpaManagement/quotations',
      name: 'quotations',
      meta: {
        title: '报价单管理',
        isMenu: true
      },
      component: () => import(/*webpackChunkName:"quotations"*/ '@/views/layout/blank.vue'),
      children:[
        {
          path: '/fpaManagement/quotations/electricityBusinessInboundQuotation',
          name: 'electricityBusinessInboundQuotation',
          meta: {
            title: '电商入驻协议报价单',
            isMenu: true
          },
          component: () => import(/*webpackChunkName:"electricityBusinessInboundQuotation"*/ '@/views/fpaManagement/quotations/electricityBusinessInboundQuotation.vue'),
        },
        {
          path: '/fpaManagement/quotations/electricityBusinessInboundQuotationDetail',
          name: 'electricityBusinessInboundQuotationDetail',
          meta: {
            title: '电商入驻协议报价单详情',
            isMenu: true
          },
          component: () => import(/*webpackChunkName:"electricityBusinessInboundQuotationDetail"*/ '@/views/fpaManagement/quotations/electricityBusinessInboundQuotationDetail.vue'),
        },
      ]
    },
    {
      path: '/fpaManagement/theCustomerServiceManaging',
      name: 'theCustomerServiceManaging',
      meta: {
        title: '客服管理',
        isMenu: true
      },
      component: () => import(/*webpackChunkName:"theCustomerServiceManaging"*/ '@/views/layout/blank.vue'),
      children:[
        {
          path: '/fpaManagement/theCustomerServiceManaging/customerServiceList',
          name: 'customerServiceList',
          meta: {
            title: '客服列表',
            isMenu: true
          },
          component: () => import(/*webpackChunkName:"customerServiceList"*/ '@/views/fpaManagement/theCustomerServiceManaging/list.vue'),
        },
      ]
    },
    {
      path: '/fpaManagement/wechatConfiguration',
      name: 'wechatConfiguration',
      meta: {
        title: '公众号配置',
        isMenu: true
      },
      component: () => import(/*webpackChunkName:"platformSide"*/ '@/views/layout/blank.vue'),
      children: [
        {
          path: '/fpaManagement/wechatConfiguration/automaticResponse',
          name: 'automaticResponse',
          meta: {
            title: '自动回复',
            isMenu: true
          },
          component: () => import(/*webpackChunkName:"automaticResponse"*/ '@/views/fpaManagement/wechatConfiguration/automaticResponse/index.vue'),
        },
        {
          path: '/fpaManagement/wechatConfiguration/customMenu',
          name: 'customMenu',
          meta: {
            title: '自定义菜单',
            isMenu: true
          },
          component: () => import(/*webpackChunkName:" customMenu"*/ '@/views/fpaManagement/wechatConfiguration/customMenu/index.vue'),
        },
      ]
    },
    {
      path: '/fpaManagement/platformSide',
      name: 'platformSide',
      meta: {
        title: '平台方管理',
        isMenu: true
      },
      component: () => import(/*webpackChunkName:"platformSide"*/ '@/views/layout/blank.vue'),
      children:[
        {
          path: '/fpaManagement/platformSide/platformPartyList',
          name: 'platformPartyList',
          meta: {
            title: '平台方列表',
            isMenu: true
          },
          component: () => import(/*webpackChunkName:"platformPartyList"*/ '@/views/fpaManagement/platformPartyList/list.vue'),
        },
      ]
    },
    {
      path: '/fpaManagement/wechatActivities',
      name: 'wechatActivities',
      meta: {
        title: '微信H5活动管理',
        isMenu: true
      },
      component: () => import(/*webpackChunkName:"wechatActivities"*/ '@/views/layout/blank.vue'),
      children:[
        {
          path: '/fpaManagement/wechatActivities/paymentHistory',
          name: 'paymentHistory',
          meta: {
            title: '订单支付记录',
            isMenu: true
          },
          component: () => import(/*webpackChunkName:"paymentHistory"*/ '@/views/fpaManagement/paymentHistory/list.vue'),
        },
        {
          path: '/fpaManagement/wechatActivities/channel',
          name: 'channel',
          meta: {
            title: '渠道列表',
            isMenu: true
          },
          component: () => import(/*webpackChunkName:"channel"*/ '@/views/fpaManagement/channel/list.vue'),
        },
        {
          path: '/fpaManagement/wechatActivities/activity',
          name: 'activity',
          meta: {
            title: '活动列表',
            isMenu: true
          },
          component: () => import(/*webpackChunkName:"activity"*/ '@/views/fpaManagement/activity/list.vue'),
        },
      ]
    },
    {
      path: '/fpaManagement/CollectionOfTaxRefundEnterpriseInformation',
      name: 'CollectionOfTaxRefundEnterpriseInformation',
      meta: {
        title: '退税企业资料收集',
        isMenu: true
      },
      component: () => import(/*webpackChunkName:"CollectionOfTaxRefundEnterpriseInformation"*/ '@/views/layout/blank.vue'),
      children:[
        {
          path: '/fpaManagement/CollectionOfTaxRefundEnterpriseInformation/businessQuestionnaire',
          name: 'businessQuestionnaire',
          meta: {
            title: '企业调查表',
            isMenu: true
          },
          component: () => import(/*webpackChunkName:"businessQuestionnaire"*/ '@/views/fpaManagement/CollectionOfTaxRefundEnterpriseInformation/businessQuestionnaire/list.vue'),
        },
        {
          path: '/fpaManagement/CollectionOfTaxRefundEnterpriseInformation/questionaryDetail',
          name: 'questionaryDetail',
          meta: {
            title: '企业调查表',
          },
          component: () => import(/*webpackChunkName:"questionaryDetail"*/ '@/views/fpaManagement/CollectionOfTaxRefundEnterpriseInformation/businessQuestionnaire/detail.vue'),
        },
        {
          path: '/fpaManagement/CollectionOfTaxRefundEnterpriseInformation/dataListConfiguration',
          name: 'dataListConfiguration',
          meta: {
            title: '资料清单配置',
          },
          component: () => import(/*webpackChunkName:"dataListConfiguration"*/ '@/views/fpaManagement/CollectionOfTaxRefundEnterpriseInformation/dataListConfiguration.vue'),
        },
      ]
    },
    {
      path: '/fpaManagement/aiFullyManaged',
      name: 'aiFullyManaged',
      meta: {
        title: 'AI退税全托管',
        isMenu: true,
      },
      redirect:'/fpaManagement/aiFullyManaged/index',
      component: () => import(/*webpackChunkName:"aiFullyManaged"*/ '@/views/layout/blank.vue'),
      children:[
        {
          path: '/fpaManagement/aiFullyManaged/index',
          name: 'aiFullyManagedIndex',
          meta: {
            title: 'AI退税全托管',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"aiFullyManagedIndex"*/ '@/views/fpaManagement/aiFullyManaged/list.vue'),
        },
      ]
    },
    {
      path: '/fpaManagement/smartChat',
      name: 'smartChat',
      meta: {
        title: '智能客服管理',
        isMenu: true,
      },
      redirect:'/fpaManagement/smartChat/groupMessage',
      component: () => import(/*webpackChunkName:"smartChat"*/ '@/views/layout/blank.vue'),
      children:[
        {
          path: '/fpaManagement/smartChat/groupMessage',
          name: 'groupMessage',
          meta: {
            title: '消息记录',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"groupMessage"*/ '@/views/fpaManagement/smartChat/groupMessage.vue'),
        },
        {
          path: '/fpaManagement/smartChat/kbManagement',
          name: 'kbManagement',
          meta: {
            title: '知识库管理',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"kbManagement"*/ '@/views/fpaManagement/smartChat/kbManagement/index.vue'),
        },
        {
          path: '/fpaManagement/smartChat/uploadFile',
          name: 'uploadFile',
          meta: {
            title: '知识库文件上传',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"uploadFile"*/ '@/views/fpaManagement/smartChat/kbManagement/uploadFile.vue'),
        },
        {
          path: '/fpaManagement/smartChat/edit',
          name: 'smartEdit',
          meta: {
            title: '知识库编辑',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"edit"*/ '@/views/fpaManagement/smartChat/kbManagement/edit.vue'),
        },
        {
          path: '/fpaManagement/smartChat/kbDebug',
          name: 'kbDebug',
          meta: {
            title: '知识库调试',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"kbDebug"*/ '@/views/fpaManagement/smartChat/kbDebug.vue'),
        },
      ]
    },
    {
      path: '/fpaManagement/MessagePush',
      name: 'MessagePush',
      meta: {
        title: '消息推送管理',
        isMenu: true,
      },
      redirect:'/fpaManagement/MessagePush/messageTaskManagement',
      component: () => import(/*webpackChunkName:"MessagePush"*/ '@/views/layout/blank.vue'),
      children:[
        {
          path: '/fpaManagement/MessagePush/messageTaskManagement',
          name: 'messageTaskManagement',
          meta: {
            title: '推送任务管理',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"messageTaskManagement"*/ '@/views/fpaManagement/MessagePush/messageTaskManagementList.vue'),
        },
      ]
    }
  ]
}
//金融服务模块
export const financeRouters:RouteRecordRaw = {
  path: '/finance',
  name: 'finance',
  redirect: '/finance/tradeLoan/tradeloanAmountApplication',
  component: () => import(/*webpackChunkName:"finance"*/ '@/views/layout/layout.vue'),
  meta: {
    title: '金融服务',
    isMenu: true
  },
  children: [
    {
      path: '/finance/tradeLoan',
      name: 'tradeLoan',
      meta: {
        title: '贸易贷款',
        isMenu: true
      },
      component: () => import(/*webpackChunkName:"tradeLoan"*/ '@/views/layout/blank.vue'),
      children: [
        {
          path: '/finance/tradeLoan/tradeloanAmountApplication',
          name: 'tradeloanAmountApplication',
          meta: {
            title: '贷款额度申请&支用',
            isMenu: true
          },
          component: () => import(/*webpackChunkName:"tradeloanAmountApplication"*/ '@/views/finance/tradeLoan/tradeloanAmountApplication.vue')
        },
        {
          path: '/finance/tradeLoan/tradeloanAmountApplication/tradeloanAmountApplicationH5',
          name: 'tradeloanAmountApplicationH5',
          meta: {
            isMenu: false
          },
          component: () => import(/*webpackChunkName:"tradeloanAmountApplicationH5"*/ '@/views/finance/tradeLoan/h5.vue'),
        },
      ]
    },
    {
      path: '/finance/taxRefundLoan',
      name: 'taxRefundLoan',
      meta: {
        title: '退税贷款',
        isMenu: true
      },
      component: () => import(/*webpackChunkName:"taxRefundLoan"*/ '@/views/layout/blank.vue'),
      children: [
        {
          path: '/finance/taxRefundLoan/taxRefundloanAmountApplication',
          name: 'taxRefundloanAmountApplication',
          meta: {
            title: '贷款额度申请&支用',
            isMenu: false
          },
          component: () => import(/*webpackChunkName:"taxRefundloanAmountApplication"*/ '@/views/finance/taxRefundLoan/taxRefundloanAmountApplication.vue'),
        },
      ]
    },
    {
      path: '/finance/creditLoans',
      name: 'creditLoans',
      meta: {
        title: '信用贷款',
        isMenu: true
      },
      component: () => import(/*webpackChunkName:"creditLoans"*/ '@/views/layout/blank.vue'),
      children: [
        {
          path: '/finance/creditLoans/youhuiAmountApplication',
          name: 'youhuiAmountApplication',
          meta: {
            title: '贷款额度申请&支用（邮惠）',
            isMenu: false
          },
          component: () => import(/*webpackChunkName:"youhuiAmountApplication"*/ '@/views/finance/creditLoans/youhuiAmountApplication.vue'),
        },
      ]
    },
    {
      path: '/finance/authorizationManagement',
      name: 'authorizationManagement',
      meta: {
        title: '授权管理',
        isMenu: true
      },
      component: () => import(/*webpackChunkName:"authorizationManagement"*/ '@/views/layout/blank.vue'),
      children: [
        {
          path: '/finance/authorizationManagement/ycinformationQueryAuthorization',
          name: 'ycinformationQueryAuthorization',
          meta: {
            title: '信息查询授权（邮储）',
            isMenu: false
          },
          component: () => import(/*webpackChunkName:"ycinformationQueryAuthorization"*/ '@/views/finance/authorizationManage/searchAuthorization.vue'),
        },
        {
          path: '/finance/authorizationManagement/psbc/e',
          name: 'psbc',
          meta: {
            title: '商贸e贷',
            isMenu: false
          },
          component: () => import(/*webpackChunkName:"e"*/ '@/views/finance/authorizationManage/e.vue'),
        },
      ]
    },
    {
      path: '/finance/noAuthFinance/',
      name: 'noAuthFinance',
      meta: {
        title: '无权限页面',
        isMenu: true
      },
      component: () => import(/*webpackChunkName:"noAuthFinance"*/ '@/views/layout/blank.vue'),
      children: [
        {
          path: '/finance/noAuthFinance/noAuthFinanceIndex',
          name: 'noAuthFinanceIndex',
          meta: {
            title: '未开通权限',
            isMenu: false
          },
          component: () => import(/*webpackChunkName:"noAuthFinanceIndex"*/ '@/views/noAuth/index2.vue'),
        }
      ]
    },
  ]
}
//订单模块
export const orderRouters:RouteRecordRaw = {
  path: '/orders',
  name: 'orders',
  // redirect: '/orders/double/orderExport',
  component: () => import(/*webpackChunkName:"fpaManagement"*/ '@/views/layout/layout.vue'),
  meta: {
    title: '单证管理',
    isMenu: true
  },
  children:[
    {
      path: '/orders/admin',
      name: 'admin',
      meta: {
        title: '报关单列表',
        isMenu: false,
      },
      component: () => import(/*webpackChunkName:"admin"*/ '@/views/layout/blank.vue'),
      children: [
        {
          path: '/orders/admin/declareList',
          name: 'declareList',
          meta: {
            title: '报关单列表',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"declareList"*/ '@/views/order/list.vue'),
        },
        {
          path: '/orders/admin/declareList/logisticsDetail',
          name: 'logisticsDetail',
          meta: {
            title: '物流查询',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"declareList"*/ '@/views/order/logisticsDetail.vue'),
        },
        {
          path: '/orders/admin/declareList/logisticsDetail2',
          name: 'logisticsDetail2',
          meta: {
            title: '物流查询',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"declareList"*/ '@/views/order/logisticsDetail2.vue'),
        },
        {
          path: '/orders/admin/declareList/declareDetail',
          name: 'declareDetail',
          meta: {
            title: '报关单详情',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"declareDetail"*/ '@/views/order/list/0110/detail.vue'),
        },
        {
          path: '/orders/admin/declareList/declareDetail9610',
          name: 'declareDetail9610',
          meta: {
            title: '报关单详情',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"declareDetail9610"*/ '@/views/order/list/detail9610.vue'),
        },
        {
          path: '/orders/admin/declareList/relationOrder',
          name: 'relationOrder',
          meta: {
            title: '关联单证',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"relationOrder"*/ '@/views/order/list/relationOrder.vue'),
        },
        {
          path: '/orders/admin/declare9610List',
          name: 'declare9610List',
          meta: {
            title: '9610清单列表',
            isMenu: false,
            },
          component: () => import(/*webpackChunkName:"declare9610List"*/ '@/views/order/list/9610/detail-list.vue'),
        },
        {
          path: '/orders/admin/declareList/declare9610ListDetail',
          name: 'declare9610ListDetail',
          meta: {
            title: '报关单详情',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"declare9610ListDetail"*/ '@/views/order/list/9610/detail-list-detail.vue'),
        },
        {
          path: '/orders/saleOrderDetail',
          name: 'saleOrderDetail',
          meta: {
            title: '关联单据',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"saleOrderDetail"*/ '@/views/order/list/saleOrderDetail.vue'),
        },
      ]
    },
    {
      path: '/orders/record',
      name: 'record',
      component: () => import(/*webpackChunkName:"record"*/ '@/views/layout/blank.vue'),
      meta: {
        title: '退税单证备案',
        isMenu: true
      },
      children:[
        {
          path: '/orders/record/parameters',
          name: 'parameters',
          component: () => import(/*webpackChunkName:"parameters"*/ '@/views/order/record/parameters.vue'),
          meta: {
            title: '退税参数管理',
            isMenu: true
          },
        },
        {
          path: '/orders/record/purchasing',
          name: 'purchasing',
          component: () => import(/*webpackChunkName:"purchasing"*/ '@/views/order/record/purchasing.vue'),
          meta: {
            title: '采购订单备案',
            isMenu: true
          },
        },
        {
          path: '/orders/record/sales',
          name: 'sales',
          component: () => import(/*webpackChunkName:"sales"*/ '@/views/order/record/sales.vue'),
          meta: {
            title: '销售订单备案',
            isMenu: true
          },
        },
        {
          path: '/orders/record/bookingOrder',
          name: 'bookingOrder',
          component: () => import(/*webpackChunkName:"bookingOrder"*/ '@/views/order/record/bookingOrder.vue'),
          meta: {
            title: '订仓单备案',
            isMenu: true
          },
        },
        {
          path: '/orders/record/billOfLading',
          name: 'billOfLading',
          component: () => import(/*webpackChunkName:"billOfLading"*/ '@/views/order/record/billOfLading.vue'),
          meta: {
            title: '提运单',
            isMenu: true
          },
        },
        {
          path: '/orders/record/customsDeclarationEntrustment',
          name: 'customsDeclarationEntrustment',
          component: () => import(/*webpackChunkName:"customsDeclarationEntrustment"*/ '@/views/order/record/customsDeclarationEntrustment.vue'),
          meta: {
            title: '委托报关协议',
            isMenu: true
          },
        },
        {
          path: '/orders/record/commodityClassification',
          name: 'commodityClassification',
          component: () => import(/*webpackChunkName:"commodityClassification"*/ '@/views/order/record/commodityClassification.vue'),
          meta: {
            title: '商品归类',
            isMenu: true
          },
        },
        {
          path: '/orders/record/amazonOrderData',
          name: 'amazonOrderData',
          component: () => import(/*webpackChunkName:"amazonOrderData"*/ '@/views/order/record/amazonOrderData.vue'),
          meta: {
            title: '亚马逊订单数据',
            isMenu: true
          },
        },
        {
          path: '/orders/record/receiptData',
          name: 'receiptData',
          component: () => import(/*webpackChunkName:"receiptData"*/ '@/views/order/record/receipt.vue'),
          meta: {
            title: '收款单备案',
            isMenu: true
          },
        },
        {
          path: '/orders/record/peliveryPlan',
          name: 'peliveryPlan',
          component: () => import(/*webpackChunkName:"peliveryPlan"*/ '@/views/order/record/peliveryPlan/list.vue'),
          meta: {
            title: '发货计划',
            isMenu: true
          },
        },
      ]
    },
    {
      path:'/orders/exportInvoiceManagement',
      name:'exportInvoiceManagement',
      meta:{
        title: '出口发票管理',
        isMenu: true,
       },
       component: () => import(/*webpackChunkName:"exportInvoiceManagement"*/ '@/views/layout/blank.vue'),
       children:[
        {
          path: '/orders/exportInvoiceManagement/invoicingDataExport',
          name: 'invoicingDataExport',
          meta: {
            title: '开票数据导出',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"invoicingDataExport"*/ '@/views/order/exportInvoiceManagement/invoicingDataExport.vue'),
        },
        {
          path: '/orders/exportInvoiceManagement/invoicingDataImport',
          name: 'invoicingDataImport',
          meta: {
            title: '发票数据导入',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"invoicingDataImport"*/ '@/views/order/exportInvoiceManagement/invoicingDataImport.vue'),
        },
        {
          path: '/orders/exportInvoiceManagement/invoicingDataImport/invoicingDataImportDetail',
          name: 'invoicingDataImportDetail',
          meta: {
            title: '发票数据-详情',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"invoicingDataImportDetail"*/ '@/views/order/exportInvoiceManagement/invoicingDataImportDetail.vue'),
        },
        {
          path: '/orders/exportInvoiceManagement/taxCode',
          name: 'taxCode',
          meta: {
            title: '税务编码',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"taxCode"*/ '@/views/order/exportInvoiceManagement/taxCode.vue'),
        },
        {
          path: '/orders/exportInvoiceManagement/invoicingDataDetail',
          name: 'invoicingDataDetail',
          meta: {
            title: '开票数据详情',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"invoicingDataDetail"*/ '@/views/order/exportInvoiceManagement/invoicingDataDetail.vue'),
        },
        {
          path: '/orders/exportInvoiceManagement/IntelligentOrderMatching',
          name: 'IntelligentOrderMatching',
          meta: {
            title: '智能配单',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"IntelligentOrderMatching"*/ '@/views/order/IntelligentOrderMatching/list.vue'),
        },
       ],
    },
    {
      path: '/orders/double',
      name: 'double',
      meta: {
        title: '委托单',
        isMenu: true,
      },
      component: () => import(/*webpackChunkName:"double"*/ '@/views/layout/blank.vue'),
      children: [
        {
          path: '/orders/double/orderQuick',
          name: 'orderQuick',
          meta: {
            title: '快捷下单',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"orderQuick"*/ '@/views/order/quick.vue'),
        },

        {
          path: '/orders/double/orderExport',
          name: 'orderExport',
          meta: {
            title: '订单列表',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"orderExport"*/ '@/views/order/export.vue'),
        },
        {
          path: '/orders/double/orderExport/doubleDetail',
          name: 'doubleDetail',
          meta: {
            title: '详情',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"orderDetail"*/ '@/views/order/detail.vue'),
        },
        // {
        //   path:'/order/entrusted',
        //   name:'orderEntrusted',
        //   meta:{
        //     title:'被委托订单',
        //     isMenu:true,
        //   },
        //   component: () => import(/*webpackChunkName:"orderEntrusted"*/ '@/views/order/entrusted.vue'),
        // },
      ]
    },
    {
      path: '/orders/arrivedVehicleList',
      name: 'arrivedVehicleList',
      component: () => import(/*webpackChunkName:"arrivedVehicleList"*/ '@/views/order/arrivedVehicleList.vue'),
      meta: {
        title: '运抵车辆列表',
        isMenu: true
      },
    },
    {
      path: '/orders/transportationList',
      name: 'transportationList',
      component: () => import(/*webpackChunkName:"transportationList"*/ '@/views/order/transportationList.vue'),
      meta: {
        title: '运单列表',
        isMenu: true
      },
    },
    {
      path: '/orders/logisticsTrajectory',
      name: 'logisticsTrajectory',
      component: () => import(/*webpackChunkName:"logisticsTrajectory"*/ '@/views/order/logisticsTrajectory.vue'),
      meta: {
        title: '物流轨迹',
        isMenu: true
      },
    },
    {
      path: '/orders/shippedVehicleList',
      name: 'shippedVehicleList',
      component: () => import(/*webpackChunkName:"shippedVehicleList"*/ '@/views/order/shippedVehicleList.vue'),
      meta: {
        title: '已发运车辆列表',
        isMenu: true
      },
    },
    {
      path: '/orders/importCommission',
      name: 'importCommission',
      meta: {
        title: '进口委托',
        isMenu: true,
      },
      component: () => import(/*webpackChunkName:"importCommission"*/ '@/views/layout/blank.vue'),
      children: [
        {
          path: '/orders/importCommission/addImportAuthorizationForm',
          name: 'addImportAuthorizationForm',
          meta: {
            title: '新增进口委托单',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"addImportAuthorizationForm"*/ '@/views/importCommission/addImportAuthorizationForm.vue'),
        },

        {
          path: '/orders/importCommission/importCommissionList',
          name: 'importCommissionList',
          meta: {
            title: '进口委托单列表',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"importCommissionList"*/ '@/views/importCommission/importCommissionList.vue'),
        },
        {
          path: '/orders/double/orderExport/doubleDetail',
          name: 'doubleDetail',
          meta: {
            title: '详情',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"orderDetail"*/ '@/views/order/detail.vue'),
        },
        // {
        //   path:'/order/entrusted',
        //   name:'orderEntrusted',
        //   meta:{
        //     title:'被委托订单',
        //     isMenu:true,
        //   },
        //   component: () => import(/*webpackChunkName:"orderEntrusted"*/ '@/views/order/entrusted.vue'),
        // },
      ]
    },
    {
      path: '/orders/waybillManagement',
      name: 'waybillManagement',
      meta: {
        title: '运单管理',
        isMenu: true,
      },
      component: () => import(/*webpackChunkName:"waybillManagement"*/ '@/views/layout/blank.vue'),
      children: [
        {
          path: '/orders/waybillManagement/importWaybillList',
          name: 'importWaybillList',
          meta: {
            title: '进口运单列表',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"importWaybillList"*/ '@/views/order/waybillManagement/list.vue'),
        },
      ]
    },
    {
      path: '/orders/noAuthOrder',
      name: 'noAuthOrder',
      meta: {
        title: '无权限页面',
        isMenu: true
      },
      component: () => import(/*webpackChunkName:"noAuthOrder"*/ '@/views/layout/blank.vue'),
      children: [
        {
          path: '/orders/noAuthOrder/noAuthOrderIndex',
          name: 'noAuthOrderIndex',
          meta: {
            title: '未开通权限',
            isMenu: false
          },
          component: () => import(/*webpackChunkName:"noAuthOrderIndex"*/ '@/views/noAuth/index.vue'),
        }
      ]
    },
    // {
    //   path: '/orders/agent',
    //   name: 'agent',
    //   meta: {
    //     title: '代理报关',
    //     isMenu: false,
    //   },
    //   component: () => import(/*webpackChunkName:"agent"*/ '@/views/layout/blank.vue'),
    //   children: [
    //     {
    //       path: '/orders/agent/customsBroker',
    //       name: 'customsBroker',
    //       meta: {
    //         title: '代理报关',
    //         isMenu: true,
    //       },
    //       component: () => import(/*webpackChunkName:"customsBroker"*/ '@/views/order/customsBroker.vue'),
    //     }
    //   ]
    // },
  ]
}
// 问诊模块
export const consultationRouters: RouteRecordRaw = {
  path: '/consultation',
  name: 'consultation',
  redirect: '/consultation/customerManagement/customerList',
  component: () => import(/*webpackChunkName:"consultation"*/ '@/views/layout/layout.vue'),
  meta: {
    title: '问诊',
    isMenu: true
  },
  children:[
    {
      path: '/consultation/customerManagement）',
      name: 'customerManagement）',
      meta: {
        title: '客户管理',
        isMenu: false,
      },
      component: () => import(/*webpackChunkName:"customerManagement）"*/ '@/views/layout/blank.vue'),
      children: [
        {
          path: '/consultation/customerManagement/customerList',
          name: 'customerList',
          meta: {
            title: '客户列表',
            isMenu: false,
          },
          component: () => import(/*webpackChunkName:"customerList）"*/ '@/views/consultation/customerManagement/list.vue'),
        },
      ]
    },
  ]
}
//财务模块
export const accountingRouters:RouteRecordRaw = {
  path: '/accounting',
  name: 'accounting',
  redirect: '/accounting/managementOfInvoices/invoicingApplicationList',
  component: () => import(/*webpackChunkName:"fpaManagement"*/ '@/views/layout/layout.vue'),
  meta: {
    title: '财务',
    isMenu: true
  },
  children:[
    {
      path: '/accounting/managementOfInvoices',
      name: 'managementOfInvoices',
      meta: {
        title: '发票管理',
        isMenu: true,
      },
      component: () => import(/*webpackChunkName:"managementOfInvoices"*/ '@/views/layout/blank.vue'),
      children: [
        {
          path: '/accounting/managementOfInvoices/invoicingApplicationList',
          name: 'invoicingApplicationList',
          meta: {
            title: '开票申请单列表',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"invoicingApplicationList"*/ '@/views/accounting/managementOfInvoices/invoicingApplicationList.vue'),
        },
        {
          path: '/accounting/managementOfInvoices/invoiceList',
          name: 'invoiceList',
          meta: {
            title: '发票列表',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"invoiceList"*/ '@/views/accounting/managementOfInvoices/invoiceList.vue'),
        },
      ]
    },
    {
      path: '/accounting/paymentManagement',
      name: 'paymentManagement',
      meta: {
        title: '付汇管理',
        isMenu: true,
      },
      component: () => import(/*webpackChunkName:"paymentManagement"*/ '@/views/layout/blank.vue'),
      children: [
        {
          path: '/accounting/paymentManagement/paymentApplicationList',
          name: 'paymentApplicationList',
          meta: {
            title: '付汇申请单列表',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"paymentApplicationList"*/ '@/views/accounting/paymentManagement/paymentApplicationList.vue'),
        },
        {
          path: '/accounting/paymentManagement/paymentApplication',
          name: 'paymentApplication',
          meta: {
            title: '付汇申请',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"paymentApplication"*/ '@/views/accounting/paymentManagement/paymentApplication.vue'),
        },
      ]
    },
  ]
}
//仓储管理模块
export const warehousingRouters:RouteRecordRaw = {
  path: '/warehousing',
  name: 'warehousing',
  redirect: '/warehousing/warehouse/receipt',
  component: () => import(/*webpackChunkName:"warehousing"*/ '@/views/layout/layout.vue'),
  meta: {
    title: '仓储',
    isMenu: true
  },
  children:[
    {
      path: '/warehousing/warehouse',
      name: 'warehouse',
      meta: {
        title: '入库管理',
        isMenu: true,
      },
      component: () => import(/*webpackChunkName:"warehouse"*/ '@/views/layout/blank.vue'),
      children: [
        {
          path: '/warehousing/warehouse/receipt',
          name: 'receipt',
          meta: {
            title: '入仓单列表',
            isMenu: true,
          },
          component: () => import(/*webpackChunkName:"receipt"*/ '@/views/warehousing/warehouse/receipt/list.vue'),
        },
      ]
    }
  ]
}